
import { StockIn } from "@/models/base";
import Vue from "vue";

export default Vue.extend({
	props: {
		row: {
			type: Object as () => StockIn,
			required: true
		}
	},
	methods: {
		edit() {
			this.$emit("edit");
		},
		remove() {
			this.$emit("remove");
		}
	}
});
